export function postMessageIntoApp(data) {
    window.parent.postMessage({
        "isBookingModuleAction": true,
        ...data
    }, process.env.WWW_APP_ORIGIN)


    window.parent.postMessage({
        "isBookingModuleAction": true,
        ...data
    }, process.env.APP_ORIGIN)
}